import clsx from 'clsx';
import React from 'react';

import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { withStyles, makeStyles } from 'tss-react/mui';

const StyledButton = withStyles(MuiButton, theme => ({
  root: {
    borderRadius: 0,
    fontSize: 14,
    padding: '6px 16px',
    lineHeight: '24px',
    fontWeight: 400,
    letterSpacing: 1,
  },

  text: {
    border: '1px solid transparent',
  },

  contained: {
    border: '1px solid transparent',
  },

  sizeSmall: {
    fontSize: 13,
    padding: '4px 10px',
    lineHeight: '22px',
  },
  sizeLarge: {
    fontSize: 15,
    padding: '8px 22px',
    lineHeight: '26px'
  },
  outlined: {
    backgroundColor: theme.palette.common.white,
  }
}));


const useStyles = makeStyles({ name: 'UpliftButton' })({
  bold: {
    fontWeight: 450,
  }
});


export type ButtonProps<C extends React.ElementType = 'button'> = {
  bold?: boolean;
} & MuiButtonProps<C, { component?: C }>;


function Button_<C extends React.ElementType>(
  { bold, ...props }: ButtonProps<C>,
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  const { classes } = useStyles();

  return (
    <StyledButton
      loadingPosition="start"
      {...props}
      className={props.className}
      classes={{
        ...props.classes,
        root: clsx(props.classes?.root, {
          [classes.bold]: bold,
        })
      }}
      ref={ref}
    />
  );
}

export const Button = React.forwardRef(Button_);
